.block {
  font-size: 14px;
  line-height: 1.7;
  color: var(--ant-color-text);
  overflow-wrap: anywhere;
}

.block p,
.block blockquote,
.block ul,
.block ol {
  margin: 0 0 8px;
}

.block p:last-child {
  margin-bottom: 0;
}

.block strong {
  font-weight: 700;
  color: var(--ant-color-text-heading);
}

.block em {
  font-style: italic;
}

.block blockquote {
  padding: 4px 0 4px 12px;
  color: var(--ant-color-text-secondary);
  border-left: 3px solid var(--ant-color-primary-border);
}

.block ul,
.block ol {
  padding-left: 20px;
}

.block h1,
.block h2,
.block h3 {
  margin: 8px 0 6px;
  font-weight: 600;
  color: var(--ant-color-text-heading);
}

.inline {
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}
